module.exports = __webpack_public_path__ + "img/shape-20.676e9514.svg";